import { render } from "./ArgonSwitch.vue?vue&type=template&id=285af46d"
import script from "./ArgonSwitch.vue?vue&type=script&lang=js"
export * from "./ArgonSwitch.vue?vue&type=script&lang=js"

import exportComponent from "/home/dyam/Documentos/PROYECTOS/DKDA/mi-stock-dkda-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__